import { Company } from './Company';

export class Country {
    public id: number;
    public vat: string;
    public name: string;
    public companies: Company[] = [];

    static fromDto(c: any): Country {
        const country = new Country();

        if (!c) {
            return null;
        }

        country.id = c.id;
        country.vat = c.vat;
        country.name = c.name;
        country.companies = c.companies;

        return c;
    }
}
